import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoaderPage from "./LoaderPage";
import { isEmpty } from "../utils/utils";
import { useApi, useAppDispatch } from "../store/hooks";
import { setError, setWorkflow } from "../store/reducers";

export const GoToTheNextStep = async (
  navigate,
  dispatch,
  getWorkflow,
  setIsLoading = () => {},
) => {
  try {
    const response = await getWorkflow();
    dispatch(setWorkflow(response));

    const isValidResponse = (data) => {
      return (
        !isEmpty(data) && (!isEmpty(data.status) || !isEmpty(data.currentStep))
      );
    };

    const steps = [
      { name: "Email", path: "/EmailVerification" },
      { name: "CompanyIdentification", path: "/CompanyIdentification" },
      { name: "IdCheck", path: "/IdCheck" },
      { name: "OpenBanking", path: "/OpenBanking" },
      { name: "Agreement", path: "/Agreement" },
      { name: "SepaMandate", path: "/SepaMandate" },
      { name: "PayeeVerification", path: "/PayeeVerification" },
      { name: "IdentityInformation", path: "/IdentityInformation" },
    ];

    const getStep = (currentStep) => {
      const step = steps.find((step) => step.name === currentStep);
      return step ? step.path : "/Failure";
    };

    const getNavigationPath = (data) => {
      const { steps, currentStep } = data;
      if (steps && steps.every((step) => step.status === "Validated")) {
        return "/Success";
      }

      if (steps && steps.some((step) => step.status === "Failed")) {
        return "/Failure";
      }

      return getStep(currentStep.name);
    };

    if (!isValidResponse(response)) {
      dispatch(setError("Invalid response from server"));
      navigate("/Failure");
      return;
    }

    const navigationPath = getNavigationPath(response);
    navigate(navigationPath);
  } catch (error) {
    dispatch(setError(error.message || "Network error occurred"));
    navigate("/Failure");
  } finally {
    setIsLoading(false);
  }
};

const Step = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { getWorkflow } = useApi();
  const [isLoading, setIsLoading] = useState(true);

  const handleGoToNextStep = () => {
    GoToTheNextStep(navigate, dispatch, getWorkflow, setIsLoading);
  };

  useEffect(() => {
    handleGoToNextStep();
  }, [navigate]);

  return <>{isLoading ? <LoaderPage /> : children}</>;
};

export default Step;
